import { Box, CircularProgress, Divider, Grid2 } from '@mui/material';
import { useEffect, useState } from 'react';
import { calculateCreatedAgo } from '../../commonFunc';
import { backendHost, getAllNews } from '../../../providers/apis/blogApi';
import { HubListingCardLink } from '../../../pages/new/layout/HubListingCardLink';
import { HubPagination } from '../../../pages/new/layout/HubPagination';
import { usePaginatedItems } from '../../../pages/new/layout/usePaginatedItems';

function parseNews(newsRes) {
  return newsRes.map((nItem) => ({
    postId: nItem.Id,
    title: nItem.Title,
    postMedia: nItem.Graphic1,
    postDate: nItem.DatePublished,
    postType: nItem.ContentType || 'news',
    postName: nItem.Relevance,
    link: nItem.Source,
  }));
}

export const NewsTabContent = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const { pageItems, totalPages, currentPage, onPageChange } = usePaginatedItems(items);

  useEffect(() => {
    const loadAllNews = async () => {
      setLoading(true);
      try {
        const newsRes = await getAllNews();
        setItems(parseNews(newsRes));
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadAllNews();
  }, []);

  return (
    <Box className="w-full text-start">
      <Box className="w-full my-4">
        <Grid2 container spacing={2}>
          <Grid2
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            className="text-start text-white p-6 rounded-2xl min-h-[400px]"
            display="flex"
            flexDirection="column"
            justifyContent="end"
            alignItems="flex-start"
            sx={{
              background:
                'url("/blog-photos/News/Natural-Language-Processing-and-Semantic-Analytics-for-Insurance-image4.webp")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <h4 className="cursor-pointer text-[42px] leading-[54.6px] font-medium">News</h4>
            <Box className="cursor-pointer w-full py-3" display="flex" gap={6}>
              <p>
                You can find information about CHARLEE.AI here through CHARLEE.AI and different
                sources around the Insurtech industry. Stay on top of our latest product launches
                and upcoming projects.
              </p>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
      <Box className="w-full py-4">
        {loading ? (
          <Box className="w-full flex justify-center items-center min-h-[220px]">
            <CircularProgress />
          </Box>
        ) : (
          <Grid2 container spacing={2}>
            {pageItems.map((itemData, key) => (
              <Grid2
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                key={`${itemData.postId ?? key}-${key}`}
                size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                marginTop={2}
              >
                <HubListingCardLink item={itemData}>
                  <Box className="w-full">
                    <div className="cursor-pointer w-full aspect-[300/200] rounded-2xl blog-card overflow-hidden">
                      <img
                        src={`${backendHost}${itemData.postMedia}`}
                        alt={itemData.title}
                        className="w-full aspect-[300/200] rounded-2xl object-cover"
                        crossOrigin="anonymous"
                      />
                    </div>
                    <h6 className="cursor-pointer line-clamp-2 text-[24px] leading-[32px] font-medium my-3">
                      {itemData.title}
                    </h6>
                  </Box>
                  <Box
                    className="cursor-pointer w-full mt-4 text-[#949494] text-[12px] leading-[21px]"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    gap={4}
                  >
                    <span>{calculateCreatedAgo(itemData)}</span>
                  </Box>
                </HubListingCardLink>
              </Grid2>
            ))}
          </Grid2>
        )}
      </Box>
      <Divider className="border-gray-200" />
      <Box className="w-full py-6 md:py-8">
        <HubPagination count={totalPages} page={currentPage} onChange={onPageChange} />
      </Box>
    </Box>
  );
};
